import { lazy } from 'react';
import { RouteRegistry } from './RouteRegistry';

const MainDashboard = lazy(() => import('@/pages/dashboard/MainDashboard'));
const UserProfile = lazy(() => import('@/pages/profile/UserProfile'));
const TrackingDashboard = lazy(() => import('@/components/tracking/TrackingExternalRedirect'));
const PerformanceDashboard = lazy(() => import('@/pages/dashboard/PerformanceDashboard'));
const ReportsDashboard = lazy(() => import('@/pages/dashboard/reports-dashboard'));
const Settings = lazy(() => import('@/pages/general/Settings'));
const DocumentsPage = lazy(() => import('@/pages/documents/DocumentsPage'));
const BookingsPage = lazy(() => import('@/pages/bookings/BookingsPage'));
const InvoicesPage = lazy(() => import('@/pages/invoices/InvoicesPage'));
const AnalyticsPage = lazy(() => import('@/pages/analytics/AnalyticsPage'));
const QuotesPage = lazy(() => import('@/pages/quotes/QuotesPage'));
const ShipmentsPage = lazy(() => import('@/pages/shipments/ShipmentsPage'));
const AIAssistantPage = lazy(() => import('@/pages/ai-assistant/AIAssistantPage'));
const WalletPage = lazy(() => import("@/pages/wallet/WalletPage"));

const InquiriesListPage = lazy(() => import('@/pages/customer-portal/InquiriesListPage'));
const InquiryDetailPage = lazy(() => import('@/pages/customer-portal/InquiryDetailPage'));
const BookingDetailPage = lazy(() => import('@/pages/customer-portal/BookingDetailPage'));
const InquiryForm = lazy(() => import('@/pages/inquiries/InquiryForm'));


RouteRegistry.registerCategory({
  name: 'portal',
  order: 3,
  routes: [
    { 
      path: '/dashboard', 
      component: MainDashboard, 
      requireAuth: true, 
      layout: 'portal',
      subdomain: ['public', 'opt'],
      title: 'Dashboard'
    },
    { 
      path: '/profile', 
      component: UserProfile, 
      requireAuth: true, 
      layout: 'portal',
      subdomain: ['public', 'app', 'opt', 'admin', 'mololink'],
      title: 'My Profile'
    },
    { 
      path: '/tracking', 
      component: TrackingDashboard, 
      requireAuth: true, 
      layout: 'portal',
      subdomain: ['public', 'opt'],
      title: 'Tracking Dashboard'
    },
    { 
      path: '/performance', 
      component: PerformanceDashboard, 
      requireAuth: true, 
      layout: 'portal',
      subdomain: ['public', 'opt'],
      title: 'Performance Dashboard'
    },
    { 
      path: '/reports', 
      component: ReportsDashboard, 
      requireAuth: true, 
      layout: 'portal',
      subdomain: ['public', 'opt'],
      title: 'Reports Dashboard'
    },
    { 
      path: '/settings', 
      component: Settings, 
      requireAuth: true, 
      layout: 'portal',
      subdomain: ['public', 'app', 'opt', 'admin'],
      title: 'Settings'
    },
    { 
      path: '/documents', 
      component: DocumentsPage, 
      requireAuth: true, 
      layout: 'portal',
      subdomain: ['app', 'opt'],
      title: 'Documents'
    },
    { 
      path: '/bookings', 
      component: BookingsPage, 
      requireAuth: true, 
      layout: 'portal',
      subdomain: ['app', 'opt'],
      title: 'Bookings'
    },
    { 
      path: '/invoices', 
      component: InvoicesPage, 
      requireAuth: true, 
      layout: 'portal',
      subdomain: ['app', 'opt'],
      title: 'Invoices'
    },
    { 
      path: '/analytics', 
      component: AnalyticsPage, 
      requireAuth: true, 
      layout: 'portal',
      subdomain: ['app', 'opt'],
      title: 'Analytics'
    },
    { 
      path: '/quotes', 
      component: QuotesPage, 
      requireAuth: true, 
      layout: 'portal',
      subdomain: ['app', 'opt'],
      title: 'Quotes'
    },
    { 
      path: '/shipments', 
      component: ShipmentsPage, 
      requireAuth: true, 
      layout: 'portal',
      subdomain: ['app', 'opt'],
      title: 'Shipments'
    },
    { 
      path: "/wallet", 
      component: WalletPage, 
      requireAuth: true, 
      layout: "portal",
      subdomain: ["public", "opt"],
      title: "Wallet"
    },
    {
      path: '/ai-assistant', 
      component: AIAssistantPage, 
      requireAuth: true, 
      layout: 'portal',
      subdomain: ['app', 'opt'],
      title: 'AI Assistant'
    },
    { 
      path: '/inquiries', 
      component: InquiriesListPage, 
      requireAuth: true, 
      layout: 'portal' as const,
      subdomain: ['public', 'opt'],
      title: 'My Inquiries'
    },
    { 
      path: '/inquiries/new', 
      component: InquiryForm, 
      requireAuth: true, 
      layout: 'portal' as const,
      subdomain: ['public', 'opt'],
      title: 'New Inquiry'
    },
    { 
      path: '/inquiries/:id', 
      component: InquiryDetailPage, 
      requireAuth: true, 
      layout: 'portal' as const,
      subdomain: ['public', 'opt'],
      title: 'Inquiry Details'
    },
    { 
      path: '/bookings/:id', 
      component: BookingDetailPage, 
      requireAuth: true, 
      layout: 'portal' as const,
      subdomain: ['public', 'opt'],
      title: 'Booking Details'
    }
  ]
});

export const portalRoutes = RouteRegistry.getRoutesByCategory('portal');
